import DeliverCard from "./DeliverCard";

export default DeliverCard;
